// import { handleKeyDown, lrListofTrip } from "_services";
// import { CommonInput, CommonModal, CustomSelect } from "components";
// import { UserContext } from "context";
// import { contractRateApi } from "features";
// import { Checkbox } from "pages/User/AddUser";
// import React, { useEffect, useState, useCallback, useMemo } from "react";

// const LrFreightModal2 = (props) => {
//   const {
//     separateLr,
//     listOfFreight,
//     setListOfFreight,
//     formValue,
//     ownerShip,
//     isOpen,
//     loading, setLoading
//   } = props;
//   const { masterData } = React.useContext(UserContext);
//   const [newResponse, setNewResponse] = useState([]);



//   const freightTYpeList = [
//     { id: 6, name: "Flat Rate" },
//     { id: 1, name: "Per KOT" },
//     { id: 3, name: "Per KG" },
//     { id: 4, name: "Per QTY" },
//     { id: 5, name: "Per KMs" },

//   ];

//   const filteredArray1 = useMemo(() => {
//     return separateLr
//       .filter((item) => item._id)
//       .map((item) => ({
//         consignor_id: item?.consignor_Newid,
//         lr_id: item?.lr_id,
//       }));
//   }, [separateLr]);

//   const fetchContractRates = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await contractRateApi({
//         company_id: formValue.company_id,
//         lorry_type_id: formValue?.lorry_type_id,
//         vehicle_type_id: formValue?.vehicle_type_id,
//         vehicle_ownership: ownerShip,
//         vehicle_id: formValue?.vehicle_id,
//         supplier_id: formValue?.supplier_id,
//         // select_consignor_lr: lr_freight,
//         lr_freight: filteredArray1,
//       });
//       let newRes = [];
//       if (res?.responseCode === 200) {
//         const newRes = [...res?.data?.final_lr_list];

//         const skippedItems = [];
//         separateLr.forEach((sepItem) => {
//           // Skip items that have _id
//           if (sepItem._id) return;

//           // Find the matching entry in newRes
//           let matchingEntry = newRes?.find(
//             (lrItem) => lrItem.consignor_id === sepItem.consignor_Newid
//           );

//           if (matchingEntry) {
//             // If a match is found, add sepItem to lr_list
//             matchingEntry.lr_list.push(({ ...sepItem, contract_rates: newRes[0]?.lr_list[0]?.contract_rates, }));

//           } else {
//             // If no match, create a new entry in newRes
//             const templateEntry = newRes[0] || {};

//             // Process contract object separately if it exists
//             let contractTemplate = templateEntry.contract || {};
//             let newContract = Object.fromEntries(
//               Object.entries(contractTemplate).map(([key, value]) => {
//                 if (typeof value === "number" || key === "rate_type") {
//                   return [key, value]; // Keep numeric values and rate_type
//                 }
//                 return [key, ""]; // Set other fields to empty string
//               })
//             );

//             // Create a new entry with empty values except for rate_type & numeric values
//             const newEntry = Object.fromEntries(
//               Object.entries(templateEntry).map(([key, value]) => {
//                 if (key === "rate_type" || typeof value === "number") {
//                   return [key, value]; // Keep numeric values and rate_type
//                 }
//                 return [key, ""]; // Set other fields to empty string
//               })
//             );

//             // Add contract object and necessary properties
//             newEntry.contract = newContract;
//             newEntry.consignor_id = sepItem.consignor_Newid;
//             newEntry.lr_list = [sepItem];
//             newRes.push(newEntry);
//           }
//         });

//         newRes.map((sepItem) => {

//           if (sepItem?.contract?.consignor_id) {
//             sepItem.lr_list.forEach((lr) => {
//               const match = separateLr.find((s) => {
//                 if (!s._id) return;
//                 return s._id === lr._id;
//               });

//               if (match) {
//                 lr.tableIndex = match.tableIndex;
//               }
//             });
//           }
//         });

//         setNewResponse(newRes);

//         const updatedData = newRes.map((consignor) => {

//           const isHighestFreight = consignor?.contract
//             ? consignor?.contract?.highest_freight === 1
//             : false;
//           const multipleRatesAllowed = consignor?.contract
//             ? consignor?.contract?.multiple_rates_allowed === 1
//             : false;

//           const highestFreight = isHighestFreight
//             ? Math.max(
//               ...consignor?.lr_list.map((lr) =>
//                 lr?.contract_rates?.total_freight
//                   ? lr?.contract_rates?.total_freight
//                   : 0
//               )
//             )
//             : 0;

//           let firstSelected = false;

//           return {
//             ...consignor,
//             lr_list: consignor.lr_list.map((lr, index) => {
//               const isFirstLR = index === 0;
//               let isSelected = isFirstLR; // By default, select the first LR.

//               // If there's only one LR, select it automatically.
//               if (consignor.lr_list.length === 1) {
//                 isSelected = true;
//               }

//               // Logic for highest freight
//               if (
//                 isHighestFreight &&
//                 lr.contract_rates?.total_freight === highestFreight &&
//                 !firstSelected
//               ) {

//                 isSelected = true;
//                 firstSelected = true; // Ensure only one highest freight LR is selected.
//               }

//               // Handle multiple rates allowed condition
//               if (multipleRatesAllowed) {
//                 // Allow other checkboxes to be checked, even if highest freight is selected.
//                 if (isHighestFreight) {
//                   isSelected =
//                     lr.contract_rates?.total_freight === highestFreight
//                 }
//               } else {
//                 // If multiple rates are not allowed, only select the highest freight
//                 if (
//                   isHighestFreight &&
//                   lr.contract_rates?.total_freight !== highestFreight
//                 ) {
//                   isSelected = false; // Deselect if not the highest freight.
//                 }
//               }

//               // return {
//               //   ...lr,
//               //   ...(lr.contract_rates?.freight_type
//               //     ? {
//               //       contract_rates: {
//               //         ...lr.contract_rates,
//               //         qty: 0,
//               //         selected: isSelected,
//               //       },
//               //     }
//               //     : {
//               //       contract_rates: {
//               //         freight_type: 6,
//               //         qty: 0,
//               //         rate: 0,
//               //         selected: false,
//               //         total_freight: 0,
//               //       },
//               //     }),
//               //   ...(lr.lr_freight?.freight_type
//               //     ? {
//               //       lr_freight: {
//               //         ...lr.lr_freight,
//               //         // qty: 0,
//               //         selected: isSelected,
//               //       },
//               //     }
//               //     : {
//               //       lr_freight: {
//               //         freight_type: 6,
//               //         qty: 0,
//               //         rate: 0,
//               //         selected: false,
//               //         total_freight: 0,
//               //       },
//               //     }),

//               // };

//               return {
//                 ...lr,
//                 // Handle contract_rates
//                 ...(lr.contract_rates?.freight_type
//                   ? {
//                     contract_rates: {
//                       ...lr.contract_rates,
//                       // Check if freight_type matches any _id in contract.rate_type array
//                       ...(Array.isArray(consignor?.contract.rate_type) &&
//                         consignor?.contract.rate_type.some(type => type.id === lr.contract_rates.freight_type)
//                         ? {
//                           selected: isSelected,
//                           qty: 0, // assuming you reset qty
//                           // Keep other existing values
//                         }
//                         : {
//                           // Not allowed: reset to default
//                           freight_type: 6,
//                           qty: 0,
//                           rate: 0,
//                           total_freight: 0,
//                           selected: isSelected,
//                         }),
//                     },
//                   }
//                   : {
//                     contract_rates: {
//                       freight_type: 6,
//                       qty: 0,
//                       rate: 0,
//                       total_freight: 0,
//                       selected: false,
//                     },
//                   }),
//                 // Handle lr_freight
//                 ...(lr.lr_freight?.freight_type
//                   ? {
//                     lr_freight: {
//                       ...lr.lr_freight,
//                       // Same check for lr_freight
//                       ...(Array.isArray(consignor?.contract.rate_type) &&
//                         consignor?.contract.rate_type.some(type => type.id === lr.lr_freight.freight_type)
//                         ? {
//                           selected: isSelected,
//                           // qty: 0,
//                         }
//                         : {
//                           // Reset if not matched
//                           freight_type: 6,
//                           qty: 0,
//                           rate: 0,
//                           total_freight: 0,
//                           selected: isSelected,
//                         }),
//                     },
//                   }
//                   : {
//                     lr_freight: {
//                       freight_type: 6,
//                       qty: 0,
//                       rate: 0,
//                       total_freight: 0,
//                       selected: false,
//                     },
//                   }),
//               };
//             }),
//           };
//         });

//         setListOfFreight(updatedData);
//       } else {
//         newRes = separateLr.map((sepItem) => ({
//           consignor_id: sepItem.consignor_Newid,
//           contract: "",
//           lr_list: [sepItem],
//         }));

//         setNewResponse(newRes);

//         const updatedData = newRes.map((consignor) => {
//           const isHighestFreight = consignor?.contract
//             ? consignor?.contract?.highest_freight === 1
//             : false;
//           const multipleRatesAllowed = consignor?.contract
//             ? consignor?.contract?.multiple_rates_allowed === 1
//             : false;

//           const highestFreight = isHighestFreight
//             ? Math.max(
//               ...consignor?.lr_list.map((lr) =>
//                 lr?.contract_rates?.total_freight
//                   ? lr?.contract_rates?.total_freight
//                   : 0
//               )
//             )
//             : 0;

//           let firstSelected = false;

//           return {
//             ...consignor,
//             lr_list: consignor.lr_list.map((lr, index) => {

//               const isFirstLR = index === 0;
//               let isSelected = isFirstLR; // By default, select the first LR.

//               // If there's only one LR, select it automatically.
//               if (consignor.lr_list.length === 1) {
//                 isSelected = true;
//               }

//               // Logic for highest freight
//               if (
//                 isHighestFreight &&
//                 lr.contract_rates?.total_freight === highestFreight &&
//                 !firstSelected
//               ) {
//                 isSelected = true;
//                 firstSelected = true; // Ensure only one highest freight LR is selected.
//               }

//               // Handle multiple rates allowed condition
//               if (multipleRatesAllowed) {
//                 // Allow other checkboxes to be checked, even if highest freight is selected.
//                 if (isHighestFreight) {
//                   isSelected =
//                     lr.contract_rates?.total_freight === highestFreight ||
//                     lr.contract_rates?.qty > 0;
//                 }
//               } else {
//                 // If multiple rates are not allowed, only select the highest freight
//                 if (
//                   isHighestFreight &&
//                   lr.contract_rates?.total_freight !== highestFreight
//                 ) {
//                   isSelected = false; // Deselect if not the highest freight.
//                 }
//               }

//               return {
//                 ...lr,
//                 ...(lr.contract_rates?.freight_type
//                   ? {
//                     contract_rates: {
//                       ...lr.contract_rates,
//                       qty: 0,
//                       selected: isSelected,
//                     },
//                   }
//                   : {
//                     contract_rates: {
//                       freight_type: 6,
//                       qty: 0,
//                       rate: 0,
//                       selected: false,
//                       total_freight: 0,
//                     },
//                   }),
//                 ...(lr.lr_freight?.freight_type
//                   ? {
//                     lr_freight: {
//                       ...lr.lr_freight,
//                       qty: 0,
//                       selected: isSelected,
//                     },
//                   }
//                   : {
//                     lr_freight: {
//                       freight_type: 6,
//                       qty: 0,
//                       rate: 0,
//                       selected: false,
//                       total_freight: 0,
//                     },
//                   }),
//               };
//             }),
//           };
//         });

//         setListOfFreight(updatedData);
//       }
//     } catch (error) {
//       console.error("Error fetching contract rates", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [filteredArray1, formValue, ownerShip, setListOfFreight]);

//   useEffect(() => {
//     if (separateLr || formValue || ownerShip) {
//       fetchContractRates();
//     }
//   }, [separateLr, formValue, ownerShip, fetchContractRates]);

//   // const handleContractRateChange = useCallback(
//   //   (consignorIndex, lrIndex, field, value, chargeable_on) => {
//   //     setListOfFreight((prevList) => {

//   //       const updatedData = [...prevList];

//   //       const targetList = updatedData[consignorIndex].lr_list[lrIndex];
//   //       // const targetRate = chargeable_on
//   //       //   ? chargeable_on === 2
//   //       //     ? targetList.contract_rates
//   //       //     : targetList.lr_freight
//   //       //   : targetList.contract_rates;

//   //       const targetRate = targetList.contract_rates
//   //       // const targetRate = chargeable_on == 2
//   //       //   ? targetList.contract_rates
//   //       //   : targetList.lr_freight


//   //       if (field === "freight_type") {
//   //         targetRate.qty = 0;
//   //         targetRate.rate = 0;
//   //         targetRate.amount = 0;
//   //         targetRate.total_freight = 0;
//   //       }

//   //       if(targetRate.freight_type ==6 && field === "total_freight"){
//   //         targetRate.rate = value;
//   //       }
//   //       targetRate[field] = value;

//   //       if (targetRate?.freight_type != 6) {
//   //         if (field === "rate" || field === "qty") {
//   //           targetRate.total_freight = targetRate.rate * targetRate.qty || 0;
//   //         }
//   //       }

//   //       return updatedData;
//   //     });
//   //   },
//   //   [setListOfFreight]
//   // );
//   const handleContractRateChange = useCallback(
//     (consignorIndex, lrIndex, field, value, chargeable_on) => {
//       setListOfFreight((prevList) => {

//         const updatedData = [...prevList];
//         const targetList = updatedData[consignorIndex].lr_list[lrIndex];

//         // ✅ chargeable_on 1 ho toh lr_freight, baaki sab mein contract_rates
//         const targetRate = chargeable_on == 1
//           ? targetList.lr_freight
//           : targetList.contract_rates;

//         if (field === "freight_type") {
//           targetRate.qty = 0;
//           targetRate.rate = 0;
//           targetRate.amount = 0;
//           targetRate.total_freight = 0;
//         }

//         if (targetRate.freight_type == 6 && field === "total_freight") {
//           targetRate.rate = value;
//         }

//         targetRate[field] = value;

//         if (targetRate?.freight_type != 6) {
//           if (field === "rate" || field === "qty") {
//             targetRate.total_freight = targetRate.rate * targetRate.qty || 0;
//           }
//         }

//         return updatedData;
//       });
//     },
//     [setListOfFreight]
//   );


//   const getFreightLabel = useCallback((freightType) => {
//     switch (freightType) {
//       case 1:
//         return "KOT";
//       case 2:
//         return "Invoice";
//       case 3:
//         return "Kg";
//       case 4:
//         return "Qty";
//       case 5:
//         return "KMs";
//       case 6:
//         return "Flat";
//       default:
//         return "Qty";
//     }
//   }, []);

//   const getFreightValue = useCallback(
//     (contract, chargeableOn, contractRates, lrFreight, field = "qty") => {
//       let value;

//       if (contract?._id) {
//         value = chargeableOn === 1 ? lrFreight?.[field] : contractRates?.[field];
//       } else {
//         value = contractRates?.[field];
//       }

//       return value == 0 || value == null ? "" : value;
//     },
//     []
//   );

//   const isFreightDisabled = useCallback(
//     (consignor, chargeableOn, contractRates, lrFreight) => {
//       // return consignor?._id
//       //   ? chargeableOn === 2
//       //     ? contractRates?.freight_type == 6
//       //     : lrFreight?.freight_type === 6
//       //   : contractRates?.freight_type === 6;

//       return contractRates?.freight_type === 6;
//     },
//     []
//   );



//   const isEmpty = (obj) => Object.keys(obj).length === 0;

//   // function calculateFreight(lr, item, consignorIndex, lrIndex) {
//   //   if (lr?.contract?._id) {
//   //     // if (lr?.contract?.chargeable_on == 2) {
//   //     if (!item?.contract_rates?.freight_type) {
//   //       return 0;
//   //     } else {
//   //       if (item?.contract_rates?.freight_type !== 6) {
//   //         const freight =
//   //           item?.contract_rates?.qty * item?.contract_rates?.rate;

//   //         return freight === 0 ? "" : freight;
//   //       } else {
//   //         return item?.contract_rates?.total_freight === 0
//   //           ? ""
//   //           : item?.contract_rates?.total_freight;
//   //       }
//   //     }
//   //     // } else {
//   //     //   if (item?.lr_freight?.freight_type !== 6) {
//   //     //     const freight = item?.lr_freight?.qty * item?.lr_freight?.rate;
//   //     //     return freight === 0 ? "" : freight;
//   //     //   } else {
//   //     //     return item?.lr_freight?.total_freight === 0
//   //     //       ? ""
//   //     //       : item?.lr_freight?.total_freight;
//   //     //   }
//   //     // }
//   //   } else {
//   //     // if (!item?.contract_rates?.freight_type) {
//   //     //   return 0;
//   //     // } else {
//   //     //   if (item?.contract_rates?.freight_type !== 6) {
//   //     //     const freight =
//   //     //       item?.contract_rates?.qty * item?.contract_rates?.rate;

//   //     //     return freight === 0 ? "" : freight;
//   //     //   } else {
//   //     //     return item?.contract_rates?.total_freight === 0
//   //     //       ? ""
//   //     //       : item?.contract_rates?.total_freight;
//   //     //   }
//   //     // }
//   //     // if (lr?.contract?.chargeable_on == 2) {
//   //     if (!item?.contract_rates?.freight_type) {
//   //       return 0;
//   //     } else {
//   //       if (item?.contract_rates?.freight_type !== 6) {
//   //         const freight =
//   //           item?.contract_rates?.qty * item?.contract_rates?.rate;

//   //         return freight === 0 ? "" : freight;
//   //       } else {
//   //         return item?.contract_rates?.total_freight === 0
//   //           ? ""
//   //           : item?.contract_rates?.total_freight;
//   //       }
//   //     }
//   //     // } else {
//   //     //   if (item?.lr_freight?.freight_type !== 6) {
//   //     //     const freight = item?.lr_freight?.qty * item?.lr_freight?.rate;
//   //     //     return freight === 0 ? "" : freight;
//   //     //   } else {
//   //     //     return item?.lr_freight?.total_freight === 0
//   //     //       ? ""
//   //     //       : item?.lr_freight?.total_freight;
//   //     //   }
//   //     // }
//   //   }
//   // }

//   function calculateFreight(lr, item) {
//   // Source decide karo chargeable_on se
//   const useContractRates = !lr?.contract?._id || lr?.contract?.chargeable_on !== 1;
//   const source = useContractRates ? item?.contract_rates : item?.lr_freight;

//   // freight_type nahi he to 0
//   if (!source?.freight_type) return 0;

//   // freight_type 6 = fixed/total freight
//   if (source?.freight_type === 6) {
//     return source?.total_freight == 0 ? "" : source?.total_freight;
//   }

//   // baaki cases: qty * rate
//   const freight = source?.qty * source?.rate;
//   return freight === 0 ? "" : freight;
// }

//   const shouldDisableCheckbox = (item, consignorIndex, lr) => {
//     const isChargeableOn = lr?.contract?.chargeable_on === 2;
//     const isHighestFreight = lr.contract.highest_freight === 1;
//     const multipleRatesAllowed = lr.contract.multiple_rates_allowed === 1;
//     // When both are 0, disable all checkboxes
//     if (!multipleRatesAllowed && !isHighestFreight) {
//       return true; // Disable all checkboxes
//     }

//     if (isHighestFreight && !multipleRatesAllowed) {
//       return true; // Disable all other checkboxes when highest freight is selected but multiple rates not allowed
//     }

//     // if (isChargeableOn) {
//     const selectedCount = listOfFreight[consignorIndex].lr_list.filter(
//       (lr) => lr.contract_rates.selected
//     ).length;
//     return selectedCount <= 1 && item?.contract_rates?.selected;
//     // } else {
//     //   const selectedCount = listOfFreight[consignorIndex].lr_list.filter(
//     //     (lr) => lr.lr_freight.selected
//     //   ).length;
//     //   return selectedCount <= 1 && item?.lr_freight?.selected;
//     // }
//   };

//   function extractLRData(data) {
//     return data
//       .map((consignor) =>
//         consignor.lr_list.map((lr) => {
//           return {
//             consignor_id: consignor.consignor_id,
//             lr_id: lr._id || "",
//             from: lr?.from,
//             to: lr?.to,
//             qty: lr?.contract_rates?.qty,
//             rate: lr?.contract_rates?.rate,
//             total_freight: lr?.contract_rates?.total_freight,
//             freight_type: lr?.contract_rates?.freight_type,
//             // If _id exists, use it; otherwise, keep it empty
//           };
//         })
//       )
//       .flat(); // Flatten the array
//   }

//   const result = extractLRData(listOfFreight);

//   const inhanceProps = {
//     ...props,
//   };


//   console.log("listOfFreight", listOfFreight)

//   return (
//     <CommonModal {...inhanceProps}>
//       <div className="_lrFreightBody">
//         {separateLr ? (
//           listOfFreight?.map((lr, consignorIndex) => (
//             <div className="_lrxAll" key={`fr${consignorIndex}`}>

//               <h4 className="lrfHead">{lr?.lr_list[0]?.consignor_id?.name}</h4>
//               {lr?.lr_list?.map((item, lrIndex) => {

//                 const freightTypeOption = lr?.contract?._id ? lr?.contract?.rate_type : freightTYpeList;
//                 const generateRandomId = () => {
//                   return `checkbox-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
//                 };
//                 return (
//                   <div className="_lrx_flx" key={`fr${lrIndex}`}>
//                     <div className=" fright_size">
//                       <CommonInput
//                         type="text"
//                         label="Contract Description"
//                         value={item?.contract_id?.name}
//                         disabled
//                       />
//                     </div>
//                     <div className=" fright_size">
//                       <CommonInput
//                         type="text"
//                         label="Route"
//                         value={`${item?.from_location} - ${item?.to_location}`}
//                         disabled
//                       />
//                     </div>
//                     <div className=" fright_size">
//                       <CommonInput
//                         type="text"
//                         label="Invoice Number"
//                         value={item?.invoice_number}
//                         disabled
//                       />
//                     </div>


//                     <div className="md_size">
//                       <CustomSelect
//                         label="Freight Type"
//                         value={{
//                           label:
//                             freightTypeOption?.find(
//                               (i) =>
//                                 i?.id ===
//                                 (lr?.contract?._id
//                                   ? lr?.contract?.chargeable_on === 2
//                                     ? item?.contract_rates?.freight_type
//                                     : item?.contract_rates?.freight_type
//                                   : item?.contract_rates?.freight_type)
//                             )?.name || "Flat Rate",
//                           value:
//                             freightTypeOption?.find(
//                               (i) =>
//                                 i?.id ===
//                                 (lr?.contract?._id
//                                   ? lr?.contract?.chargeable_on === 2
//                                     ? item?.contract_rates?.freight_type
//                                     : item?.contract_rates?.freight_type
//                                   : item?.contract_rates?.freight_type)
//                             )?.id || 6,
//                         }}
//                         options={
//                           freightTypeOption?.map((v) => ({
//                             label: v.name,
//                             value: v.id,
//                           })) || []
//                         }
//                         onSelect={(data) =>
//                           handleContractRateChange(
//                             consignorIndex,
//                             lrIndex,
//                             "freight_type",
//                             data?.value,
//                             lr?.contract?.chargeable_on
//                           )
//                         }
//                         maxLength={4}

//                       />
//                     </div>

//                     <div className=" md_size">
//                       <CommonInput
//                         type="text"
//                         label={getFreightLabel(
//                           lr?.contract?.chargeable_on == 2
//                             ? item?.contract_rates?.freight_type
//                             : item?.lr_freight?.freight_type
//                         )}
//                         value={getFreightValue(
//                           lr?.contract,
//                           lr?.contract?.chargeable_on,
//                           item?.contract_rates,
//                           item?.lr_freight
//                         )}
//                         // disabled={isFreightDisabled(lr?.contract?.chargeable_on, item?.contract_rates, item?.lr_freight)}
//                         disabled={isFreightDisabled(
//                           lr?.contract,
//                           lr?.contract?.chargeable_on,
//                           item?.contract_rates,
//                           item?.lr_freight
//                         )}
//                         onKeyDown={handleKeyDown}
//                         onChange={(e) =>
//                           handleContractRateChange(
//                             consignorIndex,
//                             lrIndex,
//                             "qty",
//                             Number(e.target?.value),
//                             lr?.contract?.chargeable_on
//                           )
//                         }
//                         maxLength={4}
//                       />
//                     </div>
//                     <div className=" md_size">
//                       <CommonInput
//                         type="text"
//                         label="Rate"
//                         // value={
//                         //   lr?.contract?._id
//                         //     ? lr?.contract?.chargeable_on === 2
//                         //       ? item?.contract_rates?.rate == 0 ||
//                         //         item?.contract_rates?.rate == null
//                         //         ? ""
//                         //         : item?.contract_rates?.rate
//                         //       : item?.contract_rates?.rate == 0 ||
//                         //         item?.contract_rates?.rate == "undefined"
//                         //         ? ""
//                         //         : item?.contract_rates?.rate
//                         //     : item?.contract_rates?.rate == 0 ||
//                         //       item?.contract_rates?.rate == null
//                         //       ? ""
//                         //       : item?.contract_rates?.rate
//                         // }
//                         value={getFreightValue(
//                           lr?.contract,
//                           lr?.contract?.chargeable_on,
//                           item?.contract_rates,
//                           item?.lr_freight,
//                           "rate"
//                         )}
//                         disabled={isFreightDisabled(
//                           lr?.contract?.consignor_id,
//                           lr?.contract?.chargeable_on,
//                           item?.contract_rates,
//                           item?.lr_freight
//                         )}
//                         onKeyDown={handleKeyDown}
//                         onChange={(e) =>
//                           handleContractRateChange(
//                             consignorIndex,
//                             lrIndex,
//                             "rate",
//                             Number(e.target?.value),
//                             lr?.contract?.chargeable_on
//                           )
//                         }
//                         maxLength={4}
//                       />
//                     </div>
//                     <div className=" md_size">
//                       {lr?.contract?.visibility != 0 && (
//                         <CommonInput
//                           type="text"
//                           label="Amount (₹)"
//                           value={calculateFreight(
//                             lr,
//                             item,
//                             consignorIndex,
//                             lrIndex
//                           )}
//                           disabled={
//                             lr?.contract?._id
//                               ? lr?.contract?.visibility == 2
//                                 ? !isFreightDisabled(
//                                   lr?.contract?._id,
//                                   lr?.contract?.chargeable_on,
//                                   item?.contract_rates,
//                                   item?.contract_rates
//                                 )
//                                 : true
//                               : item?.contract_rates?.freight_type !== 6
//                           }
//                           // disabled={!isFreightDisabled(lr?.contract?.chargeable_on, item?.contract_rates, item?.lr_freight)}
//                           onKeyDown={handleKeyDown}
//                           onChange={(e) =>
//                             handleContractRateChange(
//                               consignorIndex,
//                               lrIndex,
//                               "total_freight",
//                               Number(e.target?.value),
//                               lr?.contract?.chargeable_on
//                             )
//                           }
//                           maxLength={7}
//                         />
//                       )}

//                     </div>
//                     {lr?.contract?.multiple_rates_allowed == 1 && <div className="smCheck">
//                       <Checkbox
//                         type="checkbox"
//                         id={item?._id || generateRandomId()}
//                         isChecked={
//                           lr?.contract?._id
//                             ? lr?.contract?.chargeable_on === 2
//                               ? item?.contract_rates?.selected
//                               : item?.contract_rates?.selected
//                             : item?.contract_rates?.selected
//                         }


//                         isDisabled={
//                           lr?.contract?._id
//                             ? shouldDisableCheckbox(
//                               item,
//                               consignorIndex,
//                               lr,
//                               listOfFreight
//                             )
//                             : false
//                         }
//                         handleClick={(e) =>
//                           handleContractRateChange(
//                             consignorIndex,
//                             lrIndex,
//                             "selected",
//                             e.target.checked,
//                             lr?.contract?.chargeable_on
//                           )
//                         }
//                       />
//                     </div>}
//                   </div>
//                 );
//               })}
//             </div>
//           ))
//         ) : (
//           <>Loadding..</>
//         )}
//       </div>
//     </CommonModal>
//   );
// };

// export default LrFreightModal2;


import { handleKeyDown, lrListofTrip } from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { contractRateApi } from "features";
import { Checkbox } from "pages/User/AddUser";
import React, { useEffect, useState, useCallback, useMemo } from "react";

const LrFreightModal2 = (props) => {
  const {
    separateLr,
    listOfFreight,
    setListOfFreight,
    formValue,
    ownerShip,
    isOpen,
    loading,
    setLoading,
  } = props;

  const { masterData } = React.useContext(UserContext);
  const [newResponse, setNewResponse] = useState([]);

  const freightTYpeList = [
    { id: 6, name: "Flat Rate" },
    { id: 1, name: "Per KOT" },
    { id: 3, name: "Per KG" },
    { id: 4, name: "Per QTY" },
    { id: 5, name: "Per KMs" },
  ];

  const filteredArray1 = useMemo(() => {
    return separateLr
      .filter((item) => item._id)
      .map((item) => ({
        consignor_id: item?.consignor_Newid,
        lr_id: item?.lr_id,
      }));
  }, [separateLr]);

  //   const filteredArray1 = useMemo(() => {
  //   // ✅ Saved LRs — lr_id ke saath
  //   const savedLrs = separateLr
  //     .filter((item) => item._id)
  //     .map((item) => ({
  //       consignor_id: item?.consignor_Newid,
  //       lr_id: item?.lr_id,
  //     }));

  //   // ✅ Form loads (bina _id ke) — sirf consignor_id bhejo, lr_id empty
  //   const formLoads = separateLr
  //     .filter(
  //       (item) =>
  //         !item._id &&
  //         item.consignor_Newid &&
  //         // duplicate consignor avoid karo
  //         !savedLrs.some((s) => s.consignor_id === item.consignor_Newid)
  //     )
  //     .map((item) => ({
  //       consignor_id: item?.consignor_Newid,
  //       lr_id: "",
  //     }));

  //   return [...savedLrs, ...formLoads];
  // }, [separateLr]);

  const fetchContractRates = useCallback(async () => {
    setLoading(true);
    try {
      const res = await contractRateApi({
        company_id: formValue.company_id,
        lorry_type_id: formValue?.lorry_type_id,
        vehicle_type_id: formValue?.vehicle_type_id,
        vehicle_ownership: ownerShip,
        vehicle_id: formValue?.vehicle_id,
        supplier_id: formValue?.supplier_id,
        lr_freight: filteredArray1,
      });

      let newRes = [];

      if (res?.responseCode === 200) {
        newRes = [...res?.data?.final_lr_list];

        // separateLr.forEach((sepItem) => {
        //   if (sepItem._id) return;

        //   let matchingEntry = newRes?.find(
        //     (lrItem) => lrItem.consignor_id === sepItem.consignor_Newid
        //   );

        //   if (matchingEntry) {
        //     // matchingEntry.lr_list.push({
        //     //   ...sepItem,
        //     //   contract_rates: newRes[0]?.lr_list[0]?.contract_rates,
        //     // });
        //     matchingEntry.lr_list.push({
        //       ...sepItem,
        //       contract_rates: {
        //         freight_type: sepItem.freight_type || 6,
        //         qty: sepItem.qty || 0,
        //         rate: sepItem.rate || 0,
        //         total_freight: sepItem.amount || 0,
        //         selected: true,
        //       },
        //     });
        //   } else {
        //     const templateEntry = newRes[0] || {};
        //     let contractTemplate = templateEntry.contract || {};
        //     let newContract = Object.fromEntries(
        //       Object.entries(contractTemplate).map(([key, value]) => {
        //         if (typeof value === "number" || key === "rate_type") {
        //           return [key, value];
        //         }
        //         return [key, ""];
        //       })
        //     );

        //     const newEntry = Object.fromEntries(
        //       Object.entries(templateEntry).map(([key, value]) => {
        //         if (key === "rate_type" || typeof value === "number") {
        //           return [key, value];
        //         }
        //         return [key, ""];
        //       })
        //     );

        //     newEntry.contract = newContract;
        //     newEntry.consignor_id = sepItem.consignor_Newid;
        //     // newEntry.lr_list = [sepItem];
        //     newEntry.lr_list = [{
        //       ...sepItem,
        //       contract_rates: {
        //         freight_type: sepItem.freight_type || 6,
        //         qty: sepItem.qty || 0,
        //         rate: sepItem.rate || 0,
        //         total_freight: sepItem.amount || 0,
        //         selected: true,
        //       },
        //     }];
        //     newRes.push(newEntry);
        //   }
        // });

        separateLr.forEach((sepItem) => {
          if (sepItem._id) return;
          newRes.push({
            consignor_id: sepItem.consignor_Newid,
            contract: "",
            lr_list: [{
              ...sepItem,
              contract_rates: {
                freight_type: sepItem.freight_type || 6,
                qty: sepItem.qty || 0,
                rate: sepItem.rate || 0,
                total_freight: sepItem.amount || 0,
                selected: true,
              },
            }]
          });
        });
        newRes.forEach((sepItem) => {
          if (sepItem?.contract?.consignor_id) {
            sepItem.lr_list.forEach((lr) => {
              const match = separateLr.find((s) => s._id && s._id === lr._id);
              if (match) lr.tableIndex = match.tableIndex;
            });
          }
        });

        setNewResponse(newRes);

        const updatedData = newRes.map((consignor) => {
          const isHighestFreight = consignor?.contract?.highest_freight === 1;
          const multipleRatesAllowed =
            consignor?.contract?.multiple_rates_allowed === 1;

          const highestFreight = isHighestFreight
            ? Math.max(
              ...consignor.lr_list.map(
                (lr) => lr?.contract_rates?.total_freight ?? 0
              )
            )
            : 0;

          let firstSelected = false;

          return {
            ...consignor,
            lr_list: consignor.lr_list.map((lr, index) => {
              let isSelected = index === 0;
              if (consignor.lr_list.length === 1) isSelected = true;

              if (
                isHighestFreight &&
                lr.contract_rates?.total_freight === highestFreight &&
                !firstSelected
              ) {
                isSelected = true;
                firstSelected = true;
              }

              if (multipleRatesAllowed) {
                if (isHighestFreight) {
                  isSelected =
                    lr.contract_rates?.total_freight === highestFreight;
                }
              } else {
                if (
                  isHighestFreight &&
                  lr.contract_rates?.total_freight !== highestFreight
                ) {
                  isSelected = false;
                }
              }

              // ── contract_rates ──────────────────────────────────────────

              const isFormLoad = !lr._id;

              const contractRatesPatch = isFormLoad
                ? { contract_rates: { ...lr.contract_rates, selected: isSelected } }
                : lr.contract_rates?.freight_type
                  ? {
                    contract_rates: {
                      ...lr.contract_rates,
                      ...(Array.isArray(consignor?.contract?.rate_type) &&
                        consignor.contract.rate_type.some(
                          (t) => t.id === lr.contract_rates.freight_type
                        )
                        ? { selected: isSelected, qty: 0 }
                        : {
                          freight_type: 6,
                          qty: 0,
                          rate: 0,
                          total_freight: 0,
                          selected: isSelected,
                        }),
                    },
                  }
                  : {
                    contract_rates: {
                      freight_type: 6,
                      qty: 0,
                      rate: 0,
                      total_freight: 0,
                      selected: false,
                    },
                  };
              // const contractRatesPatch = lr.contract_rates?.freight_type
              //   ? {
              //     contract_rates: {
              //       ...lr.contract_rates,
              //       ...(Array.isArray(consignor?.contract?.rate_type) &&
              //         consignor.contract.rate_type.some(
              //           (t) => t.id === lr.contract_rates.freight_type
              //         )
              //         ? { selected: isSelected, qty: 0 }
              //         : {
              //           freight_type: 6,
              //           qty: 0,
              //           rate: 0,
              //           total_freight: 0,
              //           selected: isSelected,
              //         }),
              //     },
              //   }
              //   : {
              //     contract_rates: {
              //       freight_type: 6,
              //       qty: 0,
              //       rate: 0,
              //       total_freight: 0,
              //       selected: false,
              //     },
              //   };

              // ── lr_freight ──────────────────────────────────────────────
              // const lrFreightPatch = lr.lr_freight?.freight_type
              //   ? {
              //     lr_freight: {
              //       ...lr.lr_freight,
              //       ...(Array.isArray(consignor?.contract?.rate_type) &&
              //         consignor.contract.rate_type.some(
              //           (t) => t.id === lr.lr_freight.freight_type
              //         )
              //         ? { selected: isSelected }
              //         : {
              //           freight_type: 6,
              //           qty: 0,
              //           rate: 0,
              //           total_freight: 0,
              //           selected: isSelected,
              //         }),
              //     },
              //   }
              //   : {
              //     lr_freight: {
              //       freight_type: 6,
              //       qty: 0,
              //       rate: 0,
              //       total_freight: 0,
              //       selected: false,
              //     },
              //   };
              // ── lr_freight ──────────────────────────────────────────────
              const lrFreightPatch = lr.lr_freight?.freight_type
                ? {
                  lr_freight: {
                    ...lr.lr_freight,
                    ...(Array.isArray(consignor?.contract?.rate_type) &&
                      consignor.contract.rate_type.some(
                        (t) => t.id === lr.lr_freight.freight_type
                      )
                      ? {
                        selected: isSelected,
                        // ✅ agar freight_type 6 nahi he to qty * rate se total calculate karo
                        total_freight:
                          lr.lr_freight.freight_type !== 6
                            ? (lr.lr_freight.qty ?? 0) * (lr.lr_freight.rate ?? 0) || 0
                            : lr.lr_freight.total_freight,
                      }
                      : {
                        freight_type: 6,
                        qty: 0,
                        rate: 0,
                        total_freight: 0,
                        selected: isSelected,
                      }),
                  },
                }
                : {
                  lr_freight: {
                    freight_type: 6,
                    qty: 0,
                    rate: 0,
                    total_freight: 0,
                    selected: false,
                  },
                };
              return { ...lr, ...contractRatesPatch, ...lrFreightPatch };
            }),
          };
        });

        setListOfFreight(updatedData);
      } else {
        // ── No contract found ────────────────────────────────────────────
        newRes = separateLr.map((sepItem) => ({
          consignor_id: sepItem.consignor_Newid,
          contract: "",
          lr_list: [sepItem],
        }));

        setNewResponse(newRes);

        const updatedData = newRes.map((consignor) => ({
          ...consignor,
          lr_list: consignor.lr_list.map((lr, index) => {
            const isSelected =
              consignor.lr_list.length === 1 ? true : index === 0;

            const isFormLoad = !lr._id;

            return {
              ...lr,
              contract_rates: isFormLoad
                ? {
                  // ✅ form load — top-level fields use karo (freight_type, qty, rate, amount)
                  freight_type: lr.freight_type || 6,
                  qty: lr.qty || 0,
                  rate: lr.rate || 0,
                  total_freight: lr.amount || 0,
                  selected: isSelected,
                }
                : lr.contract_rates?.freight_type
                  ? {
                    ...lr.contract_rates,
                    qty: 0,
                    selected: isSelected,
                  }
                  : {
                    freight_type: 6,
                    qty: 0,
                    rate: 0,
                    selected: false,
                    total_freight: 0,
                  },
              lr_freight: lr.lr_freight?.freight_type
                ? { ...lr.lr_freight, qty: lr._id ? 0 : lr.lr_freight.qty, selected: isSelected }
                : {
                  freight_type: lr.freight_type || 6,
                  qty: lr._id ? 0 : (lr.qty || 0),
                  rate: lr._id ? 0 : (lr.rate || 0),
                  total_freight: lr._id ? 0 : (lr.amount || 0),
                  selected: isSelected,
                },
            };
          }),
        }));

        setListOfFreight(updatedData);
      }
    } catch (error) {
      console.error("Error fetching contract rates", error);
    } finally {
      setLoading(false);
    }
  }, [filteredArray1, formValue, ownerShip, setListOfFreight]);

  useEffect(() => {
    if (separateLr || formValue || ownerShip) fetchContractRates();
  }, [separateLr, formValue, ownerShip, fetchContractRates]);

  // ── Handlers ─────────────────────────────────────────────────────────────
  const handleContractRateChange = useCallback(
    (consignorIndex, lrIndex, field, value, chargeable_on) => {
      setListOfFreight((prevList) => {
        const updatedData = [...prevList];
        const targetList = updatedData[consignorIndex].lr_list[lrIndex];

        // chargeable_on === 1 → lr_freight, else → contract_rates
        const targetRate =
          chargeable_on === 1 ? targetList.lr_freight : targetList.contract_rates;

        if (field === "freight_type") {
          // Original API values for this LR (stored in newResponse)
          const originalLR = newResponse?.[consignorIndex]?.lr_list?.[lrIndex];
          const originalSource =
            chargeable_on === 1
              ? originalLR?.lr_freight
              : originalLR?.contract_rates;

          if (originalSource?.freight_type === value) {
            // User re-selected the original type → restore original values
            targetRate.qty = originalSource.qty ?? 0;
            targetRate.rate = originalSource.rate ?? 0;
            targetRate.amount = originalSource.amount ?? 0;
            targetRate.total_freight = originalSource.total_freight ?? 0;
          } else {
            // Different type selected → reset to blank
            targetRate.qty = 0;
            targetRate.rate = 0;
            targetRate.amount = 0;
            targetRate.total_freight = 0;
          }
        }

        if (targetRate.freight_type === 6 && field === "total_freight") {
          targetRate.rate = value;
        }

        targetRate[field] = value;

        if (targetRate.freight_type !== 6 && (field === "rate" || field === "qty")) {
          targetRate.total_freight = (targetRate.rate * targetRate.qty) || 0;
        }

        return updatedData;
      });
    },
    [setListOfFreight, newResponse]
  );

  // ── Helpers ───────────────────────────────────────────────────────────────

  const getFreightLabel = useCallback((freightType) => {
    const map = { 1: "KOT", 2: "Invoice", 3: "Kg", 4: "Qty", 5: "KMs", 6: "Flat" };
    return map[freightType] ?? "Qty";
  }, []);

  /** Returns the active freight source object based on chargeable_on */
  const getFreightSource = useCallback((contract, contractRates, lrFreight) => {
    if (contract?._id && contract?.chargeable_on === 1) return lrFreight;
    return contractRates;
  }, []);

  const getFreightValue = useCallback(
    (contract, contractRates, lrFreight, field = "qty") => {
      const source = getFreightSource(contract, contractRates, lrFreight);
      const value = source?.[field];
      return value == null || value === 0 ? "" : value;
    },
    [getFreightSource]
  );

  /**
   * FIX: Disable qty/rate inputs when freight_type === 6 (Flat Rate),
   *      honouring chargeable_on to pick the correct source.
   */
  /**
   * Qty / Rate disable logic:
   *   no contract          → disable only when freight_type === 6
   *   visibility 1         → always disabled (fully read-only)
   *   visibility 2         → disable only when freight_type === 6 (same as no-contract)
   *   visibility 0         → fields hidden in JSX, but disable anyway as safety
   */
  const isFreightDisabled = useCallback(
    (contract, contractRates, lrFreight) => {

      if (contract?.chargeable_on == 1) return true;

      const source = getFreightSource(contract, contractRates, lrFreight);
      const isFlatRate = source?.freight_type === 6;

      if (!contract?._id) return isFlatRate;

      if (contract.visibility === 1) return true;   // fully read-only
      if (contract.visibility === 2) return isFlatRate; // editable only for non-flat
      return isFlatRate; // default / visibility 0
    },
    [getFreightSource]
  );

  /**
   * Amount (₹) field disabled logic:
   *   visibility 0 → hidden (already guarded in JSX)
   *   visibility 1 → always disabled (read-only)
   *   visibility 2 → editable only when freight_type === 6 (Flat Rate)
   *   no contract   → editable only when freight_type === 6
   */
  const isAmountDisabled = useCallback(
    (contract, contractRates, lrFreight) => {
      if (!contract?._id) {
        // No contract: only Flat Rate is directly editable
        return contractRates?.freight_type !== 6;
      }
      if (contract.visibility === 2) {
        // Editable only for Flat Rate, determined by active source
        const source = getFreightSource(contract, contractRates, lrFreight);
        return source?.freight_type !== 6;
      }
      // visibility 1 (or anything else) → always disabled
      return true;
    },
    [getFreightSource]
  );

  function calculateFreight(lr, item) {
    const source = getFreightSource(
      lr?.contract,
      item?.contract_rates,
      item?.lr_freight
    );
    if (!source?.freight_type) return 0;
    if (source.freight_type === 6) {
      return source.total_freight === 0 ? "" : source.total_freight;
    }
    const freight = source.qty * source.rate;
    return freight === 0 ? "" : freight;
  }

  /**
   * FIX: Guard against empty-string contract, and use correct selected field
   *      based on chargeable_on.
   */
  const shouldDisableCheckbox = useCallback(
    (item, consignorIndex, lr) => {
      if (!lr?.contract?._id) return false;

      const isHighestFreight = lr.contract.highest_freight === 1;
      const multipleRatesAllowed = lr.contract.multiple_rates_allowed === 1;

      // Both flags off → disable all
      if (!multipleRatesAllowed && !isHighestFreight) return true;
      // Highest freight but single rate only → disable all
      if (isHighestFreight && !multipleRatesAllowed) return true;

      // Multiple rates allowed: prevent de-selecting the last checked item
      const selectedCount = listOfFreight[consignorIndex].lr_list.filter(
        (l) => l.contract_rates.selected
      ).length;
      return selectedCount <= 1 && item?.contract_rates?.selected;
    },
    [listOfFreight]
  );

  // ── Active freight_type for display (select + label) ─────────────────────
  const getActiveFreightType = (contract, contractRates, lrFreight) => {
    if (contract?._id && contract?.chargeable_on === 1) {
      return lrFreight?.freight_type ?? 6;
    }
    return contractRates?.freight_type ?? 6;
  };

  console.log("listOfFreight", listOfFreight);

  const inhanceProps = { ...props };

  return (
    <CommonModal {...inhanceProps}>
      <div className="_lrFreightBody">
        {separateLr ? (
          listOfFreight?.map((lr, consignorIndex) => {
            const contract = lr?.contract;
            const chargeableOn = contract?.chargeable_on;

            return (
              <div className="_lrxAll" key={`fr${consignorIndex}`}>
                <h4 className="lrfHead">{lr?.lr_list[0]?.consignor_id?.name}</h4>

                {lr?.lr_list?.map((item, lrIndex) => {
                  const freightTypeOption = contract?._id
                    ? contract?.rate_type
                    : freightTYpeList;

                  const activeFreightType = getActiveFreightType(
                    contract,
                    item?.contract_rates,
                    item?.lr_freight
                  );

                  const generateRandomId = () =>
                    `checkbox-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;

                  return (
                    <div className="_lrx_flx" key={`fr${lrIndex}`}>
                      {/* Contract Description */}
                      <div className={contract?.visibility == 0 ? "fright_size_visible" : "fright_size"}>
                        <CommonInput
                          type="text"
                          label="Contract Description"
                          value={item?.contract_id?.name}
                          disabled
                        />
                      </div>

                      {/* Route */}
                      <div className={contract?.visibility == 0 ? "fright_size_visible" : "fright_size"}>
                        <CommonInput
                          type="text"
                          label="Route"
                          value={`${item?.from_location} - ${item?.to_location}`}
                          disabled
                        />
                      </div>

                      {/* Invoice Number */}
                      <div className={contract?.visibility == 0 ? "fright_size_visible" : "fright_size"}>
                        <CommonInput
                          type="text"
                          label="Invoice Number"
                          value={item?.invoice_number}
                          disabled
                        />
                      </div>

                      {/* Freight Type */}
                      {contract?.visibility !== 0 && (<div className="md_size">
                        <CustomSelect
                          label="Freight Type"
                          value={{
                            label:
                              freightTypeOption?.find(
                                (i) => i?.id === activeFreightType
                              )?.name ?? "Flat Rate",
                            value: activeFreightType,
                          }}
                          options={
                            freightTypeOption?.map((v) => ({
                              label: v.name,
                              value: v.id,
                            })) ?? []
                          }
                          onSelect={(data) =>
                            handleContractRateChange(
                              consignorIndex,
                              lrIndex,
                              "freight_type",
                              data?.value,
                              chargeableOn
                            )
                          }
                          maxLength={4}
                          disabled={chargeableOn == 1}
                        />
                      </div>)}

                      {/* Qty field (label changes by freight type) */}
                      {contract?.visibility !== 0 && (<div className="md_size">
                        <CommonInput
                          type="text"
                          label={getFreightLabel(activeFreightType)}
                          value={getFreightValue(
                            contract,
                            item?.contract_rates,
                            item?.lr_freight,
                            "qty"
                          )}
                          // FIX: pass contract (not chargeable_on) as first arg
                          disabled={isFreightDisabled(
                            contract,
                            item?.contract_rates,
                            item?.lr_freight
                          )}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleContractRateChange(
                              consignorIndex,
                              lrIndex,
                              "qty",
                              Number(e.target.value),
                              chargeableOn
                            )
                          }
                          maxLength={4}
                        />
                      </div>)}

                      {/* Rate */}
                      {contract?.visibility !== 0 && (<div className="md_size">
                        <CommonInput
                          type="text"
                          label="Rate"
                          value={getFreightValue(
                            contract,
                            item?.contract_rates,
                            item?.lr_freight,
                            "rate"
                          )}
                          // FIX: was passing lr?.contract?.consignor_id (wrong)
                          disabled={isFreightDisabled(
                            contract,
                            item?.contract_rates,
                            item?.lr_freight
                          )}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleContractRateChange(
                              consignorIndex,
                              lrIndex,
                              "rate",
                              Number(e.target.value),
                              chargeableOn
                            )
                          }
                          maxLength={4}
                        />
                      </div>)}

                      {/* Amount – visibility: 0=hidden, 1=read-only, 2=editable for flat */}
                      {contract?.visibility !== 0 && (<div className="md_size">

                        <CommonInput
                          type="text"
                          label="Amount (₹)"
                          value={calculateFreight(lr, item)}
                          // FIX: unified isAmountDisabled helper
                          disabled={isAmountDisabled(
                            contract,
                            item?.contract_rates,
                            item?.lr_freight
                          )}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleContractRateChange(
                              consignorIndex,
                              lrIndex,
                              "total_freight",
                              Number(e.target.value),
                              chargeableOn
                            )
                          }
                          maxLength={7}
                        />

                      </div>)}

                      {/* Checkbox – only when multiple_rates_allowed */}
                      {contract?.multiple_rates_allowed === 1 && (
                        <div className="smCheck">
                          <Checkbox
                            type="checkbox"
                            id={item?._id || generateRandomId()}
                            isChecked={item?.contract_rates?.selected}
                            // FIX: guard against empty-string contract
                            isDisabled={
                              contract?._id
                                ? shouldDisableCheckbox(item, consignorIndex, lr)
                                : false
                            }
                            handleClick={(e) =>
                              handleContractRateChange(
                                consignorIndex,
                                lrIndex,
                                "selected",
                                e.target.checked,
                                chargeableOn
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })
        ) : (
          <>Loading..</>
        )}
      </div>
    </CommonModal>
  );
};

export default LrFreightModal2;
